export default function onPointerRelease(callback) {
  this.input.onUp.add(pointer => {
    if (pointer.withinGame) {
      callback();
    }
  });
}
